import {
  DNDQ_SELECT_SEQUENCE,
  GROUPED_DNDQ_SELECT_SEQUENCE,
} from '../Redux.constants';

export const selectNewSequence = (params) => ({
  type: DNDQ_SELECT_SEQUENCE,
  payload: params,
});

export const selectNewSequenceInGroup = (params) => ({
  type: GROUPED_DNDQ_SELECT_SEQUENCE,
  payload: params,
});
